module.exports = __webpack_public_path__ + "static/undraw_version_control_9bpv-bd6fb7a31b0cd873f24d6ce47a611c55.svg";